import type { DashboardRole } from '@/types/auth';

export interface RoutePermission {
  path: string;
  requiredRoles: DashboardRole[];
}

export const RoutePermissions: RoutePermission[] = [
  {
    path: '/clients',
    requiredRoles: [
      'AUTHMATECH_SUPER_ADMIN',
      'AUTHMATECH_ADMIN',
      'AUTHMATECH_OPERATOR',
      'AUTHMATECH_SUPPORT',
    ],
  },
  {
    path: '/clients/new',
    requiredRoles: ['AUTHMATECH_SUPER_ADMIN', 'AUTHMATECH_ADMIN', 'AUTHMATECH_OPERATOR'],
  },
  {
    path: '/verifications',
    requiredRoles: [
      'AUTHMATECH_SUPER_ADMIN',
      'AUTHMATECH_ADMIN',
      'AUTHMATECH_OPERATOR',
      'AUTHMATECH_SUPPORT',
    ],
  },
  {
    path: '/my-account',
    requiredRoles: [
      'AUTHMATECH_CLIENT_ADMIN',
      'AUTHMATECH_CLIENT_OPERATOR',
      'AUTHMATECH_CLIENT_FINANCE',
      'AUTHMATECH_CLIENT_VIEWER',
    ],
  },
  {
    path: '/my-verifications',
    requiredRoles: [
      'AUTHMATECH_CLIENT_ADMIN',
      'AUTHMATECH_CLIENT_OPERATOR',
      'AUTHMATECH_CLIENT_FINANCE',
      'AUTHMATECH_CLIENT_VIEWER',
    ],
  },
  {
    path: '/reports',
    requiredRoles: [
      'AUTHMATECH_SUPER_ADMIN',
      'AUTHMATECH_ADMIN',
      'AUTHMATECH_FINANCE',
      'AUTHMATECH_VIEWER',
    ],
  },
  {
    path: '/billing',
    requiredRoles: ['AUTHMATECH_SUPER_ADMIN', 'AUTHMATECH_ADMIN', 'AUTHMATECH_FINANCE'],
  },
  {
    path: '/credits',
    requiredRoles: ['AUTHMATECH_SUPER_ADMIN', 'AUTHMATECH_ADMIN', 'AUTHMATECH_FINANCE'],
  },
  {
    path: '/settings/api-keys',
    requiredRoles: ['AUTHMATECH_SUPER_ADMIN', 'AUTHMATECH_ADMIN'],
  },
  {
    path: '/security',
    requiredRoles: ['AUTHMATECH_SUPER_ADMIN', 'AUTHMATECH_ADMIN'],
  },
];

export function hasRouteAccess(path: string, userRoles: DashboardRole[]): boolean {
  const rule = RoutePermissions.find(
    (r) => path === r.path || path.startsWith(`${r.path}/`),
  );
  if (!rule) return true;
  return rule.requiredRoles.some((role) => userRoles.includes(role));
}

export function hasAnyRole(userRoles: DashboardRole[], required: DashboardRole[]): boolean {
  return required.some((r) => userRoles.includes(r));
}
